import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  topBar: {
    height: 48,
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    flexShrink: 0,
  },
  topBarTitle: {
    color: theme.palette.white,
    fontSize: 14,
    fontWeight: 500,
  },
}))

export default useStyles
